import { Mesh, MeshStandardMaterial } from "three";
import { clone } from "three/addons/utils/SkeletonUtils.js";
import type { GLTF } from "three/examples/jsm/loaders/GLTFLoader.js";

import type { PieceName, Square } from "src/api";

import { WorldObject } from "../../../../render/world/WorldObject";
import {
  HEAP_COLOR,
  HEAP_SCALE,
  HEAP_SINK_DEPTH
} from "../../../gameConstants";
import { squareToWorld } from "../../utilities/boardCoordinates";
import { PIECE_DEFINITIONS } from "../pieces/pieceDefinitions";

export class ScrapHeap extends WorldObject {
  private readonly greyMaterial: MeshStandardMaterial;

  constructor(
    readonly scrappedPieceName: PieceName,
    gltf: GLTF,
    square: Square
  ) {
    super();

    this.greyMaterial = new MeshStandardMaterial({ color: HEAP_COLOR });
    const model = clone(gltf.scene);
    model.traverse((object) => {
      if (!(object instanceof Mesh)) return;

      object.material = this.greyMaterial;
      object.castShadow = true;
      object.receiveShadow = true;
    });

    const scale =
      (PIECE_DEFINITIONS[scrappedPieceName].scale ?? 1) * HEAP_SCALE;
    model.scale.setScalar(scale);
    this.root.add(model);
    this.root.position.copy(squareToWorld(square)).setY(-HEAP_SINK_DEPTH);
  }

  dispose() {
    this.greyMaterial.dispose();
  }
}
